import React from 'react'
import styled from 'styled-components'

const ProgressBar = styled.ol`
  margin: 0 auto;
  padding: 0 5em 0;
  list-style: none;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Node = styled.div<{ isDone: boolean }>`
  min-height: 12px;
  min-width: 12px;
  border-radius: 50%;
  margin-left: 2px;
  margin-right: 2px;
  display: inline-block;
  transition: all 1000ms ease;
  background-color: ${(props) =>
    props.isDone ? 'rgba(39, 202, 39, 1)' : '#d6d6d6'};
`

const Divider = styled.div<{ isDone: boolean }>`
  height: 1px;
  width: 100%;
  transition: all 800ms ease;
  background-color: ${(props) =>
    props.isDone ? 'rgba(39, 202, 39, 1)' : '#d6d6d6'};
`

interface HorizontalDottedStepBarProps {
  step: number
  status: string
  steps: Record<string, number>
}

const HorizontalDottedStepsBar = ({
  step,
  status,
  steps
}: HorizontalDottedStepBarProps): JSX.Element => {
  const renderDotted = () => {
    let numberOfStepDone = steps[status]
    const elements = []
    for (let i = 0; i < step; i++) {
      elements.push(
        <React.Fragment key={`node-${i}`}>
          <Node isDone={numberOfStepDone > 0} />
          {/* Hide the last divider */}
          {i !== 4 && (
            <Divider
              isDone={numberOfStepDone > 0}
              data-testid={numberOfStepDone > 0 ? 'current' : ''}
            />
          )}
        </React.Fragment>
      )
      numberOfStepDone = numberOfStepDone - 1
    }

    return elements
  }

  return (
    <ProgressBar data-testid='orderProgressList'>{renderDotted()}</ProgressBar>
  )
}

export default HorizontalDottedStepsBar
